import ImgixClient from "@imgix/js-core";
export default ImgixClient.targetWidths();
//# sourceMappingURL=targetWidths.js.map